import DisplayListFunctionalComponentV2 from "../components/DisplayListFuctionalComponentV2";
import React from "react";

const  DisplayTravelerListV2= () => {
    return (

        <div id={"DisplayListFirstPage"}>
            <div className="container-fluid">

                <div className="container">
                    <div className="row">
                        <div className="col s2"></div>
                        <div className="col s8">
                            <p id="PageTitle"> YOUR LUGGAGE</p>
                        </div>
                        <div className="col s2"></div>
                    </div>
                </div>
                <div className="row">
                    <DisplayListFunctionalComponentV2/>
                </div>
            </div>
        </div>



    );
}

export default DisplayTravelerListV2 ;